import React from "react";
import { Box } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useThemeMode } from "../ThemeContext";

export default function PublicLogoLink({
  sx = {},
  maxWidth = { xs: 160, sm: 190, md: 210 },
  themeAware = true,
}) {
  const { themeMode } = useThemeMode();
  const logoSrc =
    themeAware && themeMode === "dark"
      ? "/MediaDock_logo-dark.png"
      : "/MediaDock_logo-light-alt.png";

  return (
    <Box
      component={RouterLink}
      to="/"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        textDecoration: "none",
        mx: "auto",
        ...sx,
      }}
    >
      <Box
        component="img"
        src={logoSrc}
        alt="MediaDock logo"
        sx={{
          width: maxWidth,
          maxWidth: "100%",
          height: "auto",
        }}
      />
    </Box>
  );
}
